import {logger} from '@utils';
import {SagaIterator} from 'redux-saga';
import {put} from 'redux-saga/effects';
import * as RatingActions from '@services/rating/rating.actions';
import * as UserActions from '../user/user.actions';
import * as SuggestionWebsocket from './suggestion.websocket';

export function* createSuggestion(action: any): SagaIterator {
  try {
    if (action.payload.track) {
      const requestId:string = makeid(5);
      SuggestionWebsocket.createSuggestion(action.payload, requestId);
      yield put(UserActions.awaitReplyOnRequest(requestId));
    } else {
      SuggestionWebsocket.createSuggestion(action.payload);
    }
    yield put(RatingActions.requestRatingPrompt());
  } catch (error) {
    logger.info(error);
  }
}

export function* respondSuggestion(action: any): SagaIterator {
  try {
    SuggestionWebsocket.respondSuggestion(action.payload);
  } catch (error) {
    logger.info(error);
  }
}

export function* loadSuggestionHistory(action: any): SagaIterator {
  try {
    SuggestionWebsocket.requestSuggestionHistory(action.payload);
  } catch (error) {
    logger.info(error);
  }
}

function makeid(length:number) {
  let result           = '';
  const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for ( let i = 0; i < length; i++ ) {
     result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/services/suggestion/suggestion.saga.ts